// Datas de referência da 1ª edição (14 de Novembro de 2026, Centro Papa Giovanni, Emmenbrücke).
// FIM_1A_EDICAO = dia seguinte ao evento: a partir desta data desaparecem automaticamente
// os conteúdos específicos da 1ª edição (menu "Equipa", tabela de bilhetes para sócios, protocolo Famosa).
export const FIM_1A_EDICAO = new Date("2026-11-15T00:00:00+01:00");
export const antesDoFim1aEdicao = (agora = new Date()) => agora < FIM_1A_EDICAO;
